var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-view d-flex align-stretch",class:{
    hideList: _vm.hideList,
    hideBackdrop: _vm.hideBackdrop
  }},[_c('image-viewer',{attrs:{"zoom":_vm.zoomModel,"linear-zoom-array":_vm.$store.state.linearZoomArray,"src":_vm.images[0]},on:{"updateZoom":function (val) { return _vm.zoomModel = val; }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }